export const GET_ARTICLE_COMMENTS_FAILED = "error:knowledgeBase:get-article-comments-failed"
export const GET_ARTICLE_COMMENT_THREAD_FAILED = "error:knowledgeBase:get-comment-thread-failed"
export const SEND_ARTICLE_COMMENT_FAILED = "error:knowledgeBase:send-article-comment-failed"
export const SEND_ARTICLE_REPLY_FAILED = "error:knowledgeBase:send-article-reply-failed"
export const CONNECT_TO_HUB_FAILED = "error:knowledgeBase:connect-to-hub-failed"
export const DISCONNECT_FROM_HUB_FAILED = "error:knowledgeBase:disconnect-from-hub-failed"
